







import { Vue, Component, Watch } from 'vue-property-decorator'
import { stripePublishableKey } from '../../utils/computed'
import { namespace } from 'vuex-class'
import {
  ShippingAddressChangeEvent,
  ShippingRateChangeEvent,
  StripeBillingDetails,
  StripeShippingDetails,
  StripeShippingRate,
  ConfirmEvent
} from '../../types/stripe'

const stripe = window.Stripe(stripePublishableKey)
const cart = namespace('cart')
const user = namespace('user')

@Component
export default class StripePay extends Vue {
  @cart.State clientSecret: any
  @cart.State grandTotal: number
  @cart.State subtotal: number
  @cart.State items: Item[]
  @cart.State shipping: ServerShipping
  @cart.Action createPaymentIntent: ({ billing, shipping, rate }: {billing: StripeBillingDetails, shipping: StripeShippingDetails, rate: StripeShippingRate }) => Promise<string>
  @cart.Mutation setShippingAddress: (address: Address) => void
  @cart.Mutation setSelectedShippingService: (service: string) => void
  @cart.Mutation editStoredShippingAddress: () => void
  @cart.Action updateCart: Function

  @user.Getter loggedIn: boolean

  expressCheckoutAvailable: boolean | undefined

  data() {
    return {
      expressCheckoutAvailable: undefined
    }
  }

  async mounted () {
    console.log('StripePay mounted')

    const paymentIntent = await stripe.paymentRequest({
      total: {
        label: 'Mr. Davis',
        amount: 0,
      },
      currency: 'usd',
      country: 'US',
      requestPayerName: false,
      requestPayerEmail: false
    })

    await paymentIntent.canMakePayment().then((result: any) => {
      console.log('canMakePayment', result, !!result)
      if (result) {
        this.expressCheckoutAvailable = true
      } else {
        this.expressCheckoutAvailable = false
        this.$emit('expressCheckoutUnavailable')
      }
    })
  }

  async setShippingAddressFromStripeEvent (name: string, address: any) {
    console.log('address', address)
    this.editStoredShippingAddress()
    this.setShippingAddress({
      givenName: name,
      familyName: '',
      address_1: '',
      address_2: '',
      city: address.city,
      state: address.state,
      zip: address.postal_code,
      country: address.country,
    })
    await this.updateCart()
  }

  async setShippingRateFromStripeEvent (rate: any) {
    this.setSelectedShippingService(rate.id)

    await this.updateCart()
  }

  @Watch('subtotal')
  async onGrandTotalChange () {
    console.log('subtotal change', this.subtotal)

    const expressCheckoutOptions = {
      buttonType: {
        applePay: 'buy',
        googlePay: 'buy',
      },
      layout: {
        maxColumns: 1,
      }
    }

    const appearance = {
      theme: 'stripe',
      variables: {
        width: '100%',
        margin: 0
      }
    }

    const elements = stripe.elements({
      mode: 'payment',
      amount: this.grandTotal,
      currency: 'usd',
      appearance
    })

    const expressCheckoutElement = elements.create('expressCheckout', expressCheckoutOptions)

    expressCheckoutElement.mount(this.$refs.stripePay)

    const lineItems = this.items.map(item => ({
      name: item.sku,
      amount: item.cost,
    }))

    const shippingRates = this.shipping.rates.map(rate => ({
      id: rate.service,
      amount: rate.postage,
      displayName: rate.service,
      deliveryEstimate: `${rate.est_delivery_days} days`,
    }))

    // user clicks the Google/Apple Pay button
    expressCheckoutElement.on('click', async (event: any) => {
      console.log('click', event)
      const { resolve } = event
      resolve({
        business: {
          name: 'Mr. Davis Clothing Inc.'
        },
        emailRequired: true,
        // lineItems,
        shippingAddressRequired: true,
        shippingRates,
      })
    })

    // user changes the shipping address
    expressCheckoutElement.on('shippingaddresschange', async (event: ShippingAddressChangeEvent) => {
      const { address, name, resolve } = event
      await this.setShippingAddressFromStripeEvent(name, address)

      // update the shipping cost
      // update the tax
      elements.update({
        amount: this.grandTotal,
      })

      // could the rates be wrong here?

      resolve({ shippingRates })
    })

    expressCheckoutElement.on('shippingratechange', async (event: ShippingRateChangeEvent) => {
      const { shippingRate, resolve } = event
      // choose the shipping rate
      await this.setShippingRateFromStripeEvent(shippingRate)

      elements.update({
        amount: this.grandTotal,
      })

      resolve({ shippingRates })
    })

    expressCheckoutElement.on('cancel', async () => {
      console.log('cancel payment')
    })

    expressCheckoutElement.on('confirm', async (event: ConfirmEvent) => {
      console.log('confirm', event)

      // orders that have gift card discounts
      // orders that end up being free

      const clientSecret = await this.createPaymentIntent({
        billing: event.billingDetails,
        shipping: event.shippingAddress,
        rate: event.shippingRate
      })

      // this step could fail if the user's card is declined
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/api/express-checkout/confirm`
        }
      })

      // handle the error?
    })

    console.log('expressCheckoutElement', expressCheckoutElement)
  }
}
